// extracted by mini-css-extract-plugin
export default {"panel":"style_panel__P6184","dark":"style_dark__dc2yH"};